import {AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList} from "@angular/core";
import {NvTabComponent} from "./nv-tab.component";


@Component({
  selector: "nv-tabs",
  templateUrl: "./nv-tabs.component.html"
})


export class NvTabsComponent implements OnInit, AfterContentInit {
  @ContentChildren(NvTabComponent) children: QueryList<NvTabComponent>;
  @Input() tabsConfig: string[];

  selected: string = null;


  ngOnInit(): void {
  }


  ngAfterContentInit(): void {
    if (this.tabsConfig.length > 0) {
      this.selected = this.tabsConfig[0];
      this.updateState();
    }
  }


  onTabClick(tabName: string): void {
    this.selected = tabName;
    this.updateState();
  }


  private updateState(): void {
    this.showTabByContent(this.selected);
  }


  private showTabByContent(s: string): void {
    let selectedIndex = this.tabsConfig.indexOf(s);
    if (selectedIndex === -1) {
      return;
    }

    this.children.forEach((c: NvTabComponent, i: number): void => {
      if (selectedIndex === i) {
        c.show();
      } else {
        c.hide();
      }
    });
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-tabs/nv-tabs.component.ts